import {Component, Input, OnInit} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import {
    GaugeEvent,
    GaugeEventActionType,
    GaugeEventRelativeFromType,
    GaugeEventSetValueType,
    GaugeEventType,
    GaugeProperty,
    GaugeSettings,
    View,
    ViewEventActionType,
    ViewEventType,
    ViewType
} from '../../../_models/hmi';
import { Script, ScriptParam, SCRIPT_PARAMS_MAP } from '../../../_models/script';
import { DevicesUtils, Tag } from '../../../_models/device';

import { Utils } from '../../../_helpers/utils';
import { HtmlInputComponent } from '../../controls/html-input/html-input.component';
import { HtmlSelectComponent } from '../../controls/html-select/html-select.component';
import { ProjectService } from '../../../_services/project.service';


@Component({
    selector: 'flex-event',
    templateUrl: './flex-event.component.html',
    styleUrls: ['./flex-event.component.css']
})
export class FlexEventComponent implements OnInit {

    @Input() property: GaugeProperty;
    @Input() views: View[];
    @Input() inputs: GaugeSettings[];
    @Input() data: any;
    @Input() scripts: Script[];

    eventRunScript = Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.onRunScript);

    events: GaugeEvent[];
    eventType = <GaugeEventType>{};

    setValueType = GaugeEventSetValueType;
    enterActionType = {};
    actionType: typeof GaugeEventActionType | typeof ViewEventActionType = GaugeEventActionType;
    relativeFromType = GaugeEventRelativeFromType;
    eventActionOnCard = Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.onwindow);
    eventWithPosition = [Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.oncard),
                         Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.onwindow),
                         Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.oniframe)];
    cardDestination = Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.onwindow);
    panelDestination = Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.onViewToPanel);
    eventOnWindows = Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.oncard);
    viewPanels: PanelData[];

    eventOnOpenTab = Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.onOpenTab);
    eventOnIframe = Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.oniframe);

    constructor(
        private translateService: TranslateService,
        private projectService: ProjectService) {
    }

    ngOnInit() {

        // Events for view
        if (this.data?.type === ViewType.svg) {
            this.actionType = ViewEventActionType;
            this.eventType[Utils.getEnumKey(ViewEventType, ViewEventType.onopen)] = this.translateService.instant(ViewEventType.onopen);
            this.eventType[Utils.getEnumKey(ViewEventType, ViewEventType.onclose)] = this.translateService.instant(ViewEventType.onclose);
        } else if (this.data.settings?.type === HtmlInputComponent.TypeTag) {
            this.eventType[Utils.getEnumKey(GaugeEventType, GaugeEventType.enter)] = this.translateService.instant(GaugeEventType.enter);
            this.eventType[Utils.getEnumKey(GaugeEventType, GaugeEventType.input)] = this.translateService.instant(GaugeEventType.input);
            this.eventType[Utils.getEnumKey(GaugeEventType, GaugeEventType.blur)] = this.translateService.instant(GaugeEventType.blur);
        } else if (this.data.settings?.type === HtmlSelectComponent.TypeTag) {
            this.eventType[Utils.getEnumKey(GaugeEventType, GaugeEventType.select)] = this.translateService.instant(GaugeEventType.select);
        } else {
            this.eventType[Utils.getEnumKey(GaugeEventType, GaugeEventType.click)] = this.translateService.instant(GaugeEventType.click);
            this.eventType[Utils.getEnumKey(GaugeEventType, GaugeEventType.dblclick)] = this.translateService.instant(GaugeEventType.dblclick);
            this.eventType[Utils.getEnumKey(GaugeEventType, GaugeEventType.mousedown)] = this.translateService.instant(GaugeEventType.mousedown);
            this.eventType[Utils.getEnumKey(GaugeEventType, GaugeEventType.mouseup)] = this.translateService.instant(GaugeEventType.mouseup);
            this.eventType[Utils.getEnumKey(GaugeEventType, GaugeEventType.mouseover)] = this.translateService.instant(GaugeEventType.mouseover);
            this.eventType[Utils.getEnumKey(GaugeEventType, GaugeEventType.mouseout)] = this.translateService.instant(GaugeEventType.mouseout);
        }
        this.viewPanels = <PanelData[]>Object.values(this.data.view?.items ?? [])?.filter((item: any) => item.type === 'svg-ext-own_ctrl-panel');//#issue on build  PanelComponent.TypeTag);
        this.enterActionType[Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.onRunScript)] = this.translateService.instant(GaugeEventActionType.onRunScript);

        Object.keys(this.actionType).forEach(key => {
            this.translateService.get(this.actionType[key]).subscribe((txt: string) => { this.actionType[key] = txt; });
        });

        Object.keys(this.setValueType).forEach(key => {
            this.translateService.get(this.setValueType[key]).subscribe((txt: string) => { this.setValueType[key] = txt; });
        });

        if (this.property) {
            this.events = this.property.events;
            // compatibility with <= 1.0.4
            this.events.forEach(element => {
                if (!element.actoptions || Object.keys(element.actoptions).length == 0) {
                    element.actoptions = {
                        variablesMapping: []
                    };
                }
            });
        }
        if (!this.events || this.events.length <= 0) {
            this.onAddEvent();
        }
    }

    getEvents() {
        let result = [];
        if (this.events) {
            this.events.forEach(element => {
                if (element.type) {
                    // clean unconfig
                    if (element.action === this.eventRunScript) {
                        delete element.actoptions['variablesMapping'];
                    } else {
                        delete element.actoptions[SCRIPT_PARAMS_MAP];
                    }
                    result.push(element);
                }
            });
        }
        return result;
    }

    onAddEvent() {
        let ga: GaugeEvent = new GaugeEvent();
        this.addEvent(ga);
    }

    onRemoveEvent(index: number) {
        this.events.splice(index, 1);
    }

    onScriptChanged(scriptId, event) {
        if (event && this.scripts) {
            let script = this.scripts.find(s => s.id === scriptId);
            event.actoptions[SCRIPT_PARAMS_MAP] = [];
            if (script && script.parameters) {
                event.actoptions[SCRIPT_PARAMS_MAP] = JSON.parse(JSON.stringify(script.parameters));
            }
        }
    }

    withDestination(action) {
        let a = Object.keys(this.actionType).indexOf(action);
        let b = Object.values(this.actionType).indexOf(GaugeEventActionType.onpage);
        let c = Object.values(this.actionType).indexOf(GaugeEventActionType.onwindow);
        let d = Object.values(this.actionType).indexOf(GaugeEventActionType.ondialog);
        let e = Object.values(this.actionType).indexOf(GaugeEventActionType.onViewToPanel);
        return a > -1 && (a === b || a === c || a === d || a === e);
    }

    withPosition(eventAction: GaugeEventActionType) {
        return this.eventWithPosition.indexOf(eventAction) !== -1;
    }

    withWindows(eventAction: GaugeEventActionType) {
        return eventAction !== this.eventOnOpenTab;
    }

    withSetValue(action) {
        let a = Object.keys(this.actionType).indexOf(action);
        let b = Object.values(this.actionType).indexOf(GaugeEventActionType.onSetValue);
        return a > -1 && (a === b);
    }

    withToggleValue(action) {
        let a = Object.keys(this.actionType).indexOf(action);
        let b = Object.values(this.actionType).indexOf(GaugeEventActionType.onToggleValue);
        return a > -1 && (a === b);
    }

    withSetInput(action) {
        let a = Object.keys(this.actionType).indexOf(action);
        let b = Object.values(this.actionType).indexOf(GaugeEventActionType.onSetInput);
        return a > -1 && (a === b);
    }

    withAddress(action) {
        let a = Object.keys(this.actionType).indexOf(action);
        let b = Object.values(this.actionType).indexOf(GaugeEventActionType.oniframe);
        let c = Object.values(this.actionType).indexOf(GaugeEventActionType.oncard);
        let tab = Object.values(this.actionType).indexOf(GaugeEventActionType.onOpenTab);
        return a > -1 && (a === b || a === c || a === tab);
    }

    withSize(action) {
        let a = Object.keys(this.actionType).indexOf(action);
        let b = Object.values(this.actionType).indexOf(GaugeEventActionType.oniframe);
        let c = Object.values(this.actionType).indexOf(GaugeEventActionType.oncard);
        return a > -1 && (a === b || a === c);
    }

    withScale(action) {
        let a = Object.keys(this.actionType).indexOf(action);
        let b = Object.values(this.actionType).indexOf(GaugeEventActionType.oniframe);
        return a > -1 && (a === b);
    }

    withRunScript(action) {
        return action === this.eventRunScript;
    }

    getView(viewId: any) {
        return this.views.find(function(item) {
            return item.id === viewId;
        });
    }

    setScriptParam(scriptParam: ScriptParam, event) {
        scriptParam.value = event.variableId;
    }

    destinationWithHideClose(action: GaugeEventActionType) {
        return action === Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.onwindow) ||
            action === Utils.getEnumKey(GaugeEventActionType, GaugeEventActionType.ondialog);
    }

    isEnterOrSelect(type: string) {
        return type === 'enter' || type === 'select';
    }

    isWithPanel(action) {
        let a = Object.keys(this.actionType).indexOf(action);
        let b = Object.values(this.actionType).indexOf(GaugeEventActionType.onViewToPanel);
        return a === b;
    }

    withPublishMQTT(action) {
        let a = Object.keys(this.actionType).indexOf(action);
        let b = Object.values(this.actionType).indexOf(GaugeEventActionType.onPublishMQTT);
        return a > -1 && (a === b);
    }

    withSendWebAPI(action) {
        let a = Object.keys(this.actionType).indexOf(action);
        let b = Object.values(this.actionType).indexOf(GaugeEventActionType.onSendWebAPI);
        return a > -1 && (a === b);
    }

    private addEvent(ge: GaugeEvent) {
        if (!this.events) {
            this.events = [];
        }
        this.events.push(ge);
    }

    getDevices() {
        return this.projectService.getDeviceList();
    }

    /**
     * 自动填充绑定Tag的信息到 WebAPI Body 或 MQTT Payload
     * @param event 事件对象
     * @param type 'webapi' 或 'mqtt'
     */
    autoFillTagInfo(event: GaugeEvent, type: 'webapi' | 'mqtt') {
        if (!this.property?.variableId) {
            alert('请先绑定一个Tag变量！');
            return;
        }

        // 获取绑定的 Tag 对象
        const tag: Tag = DevicesUtils.getTagFromTagId(this.data.devices, this.property.variableId);
        if (!tag) {
            alert('未找到绑定的Tag信息！');
            return;
        }

        // 提取 address 最后一个 / 后面的内容
        let addressValue = tag.address || '';
        if (addressValue.includes('/')) {
            const parts = addressValue.split('/');
            addressValue = parts[parts.length - 1];  // 只取最后一段
        }

        // 构建简化的 JSON 数据模板（只包含 tagValue 和 address）
        const tagInfo = {
            value: '${value}',  // 固定使用 ${value}
            key: addressValue
        };

        // 根据类型填充不同字段（每次都重新生成，不管是否已存在）
        if (type === 'mqtt') {
            // MQTT Payload - 美化的 JSON 格式
            event.actoptions.mqttPayload = JSON.stringify(tagInfo, null, 2);

            // 自动生成 Topic（每次都重新生成）
            const device = DevicesUtils.getDeviceFromTagId(this.data.devices, this.property.variableId);
            event.actoptions.mqttTopic = `fuxa/${device?.name || 'device'}/${tag.name || 'tag'}`;
        } else if (type === 'webapi') {
            // WebAPI Body - 美化的 JSON 格式
            event.actoptions.webApiBody = JSON.stringify(tagInfo, null, 2);

            // 设置默认 URL 前缀（每次都重新生成）
            event.actoptions.webApiUrl = 'https://api.iccp.tdkai.cn/api/busGatewayPoint/pushMqttMsg';

            // 自动设置 Headers（每次都重新生成）
            event.actoptions.webApiHeaders = JSON.stringify({
                'Content-Type': 'application/json'
            });

            // 设置 Method（每次都重新生成）
            event.actoptions.webApiMethod = 'POST';
        }
    }
}

interface PanelData {
    id: string;
    name: string;
}
